import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1ed456ad&scoped=true&lang=pug&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.scss?vue&type=style&index=0&id=1ed456ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed456ad",
  null
  
)

export default component.exports